import React from 'react'
import { Link } from 'react-router-dom'
import {
  AlignItems,
  Box,
  FontWeight,
  Icon,
  Space,
  Text,
} from '@gousto-internal/citrus-react'
import { LinksList } from '../LinksList'
import { NavigationSections } from '../NavigationSections/NavigationSections'
import { client } from '../../config/routes'
import { FALLBACK_COLOR, FALLBACK_ICON } from '../../config/icons'
import { createSlugFromUrl } from '../../utils'
import type { Category, Section } from '../../types/entities'
import css from './NavigationCategories.module.css'

interface NavigationCategoriesProps {
  categories: Category[]
  currentTopicId: string
  sections: Section[]
}

export const NavigationCategories = ({
  categories,
  currentTopicId,
  sections,
}: NavigationCategoriesProps) => {
  const currentCategory = categories.find((category) => category.id.toString() === currentTopicId)

  const trackingProperty = (clickedCategory: Category) => (JSON.stringify({
    source_category: currentCategory?.name,
    new_category: clickedCategory.name,
  }))

  return (
    <Box paddingV={2}>
      <LinksList>
        {categories.map((category) => {
          const {
            id, htmlURL, iconName, iconColorLight, name,
          } = category
          const nameSlug = createSlugFromUrl(htmlURL)
          const isCurrentTopic = id.toString() === currentTopicId

          return (
            <div data-test="category-wrapper" key={id}>
              <Link
                to={`${client.categories}/${nameSlug}/${id}`}
                className={css.link}
                data-tracking-action="kb_click_other_help_topics_category_page"
                data-tracking-property={trackingProperty(category)}
              >
                <Box
                  className={isCurrentTopic ? css.selectedTopic : undefined}
                  display="flex"
                  alignItems={AlignItems.Center}
                  paddingV={3}
                  paddingH={3}
                >
                  <Icon
                    name={iconName || FALLBACK_ICON}
                    style={{ color: iconColorLight || FALLBACK_COLOR }}
                  />
                  <Space direction="horizontal" size={3} />
                  <Text size={3} fontWeight={FontWeight.SemiBold}>
                    {name}
                  </Text>
                </Box>
              </Link>
              {isCurrentTopic && (
                <>
                  <Space size={2} />
                  <NavigationSections sections={sections} />
                </>
              )}
            </div>
          )
        })}
      </LinksList>
    </Box>
  )
}
